import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BalanceAccountService {
  private readonly selectedAccountSubject = new BehaviorSubject<any>(null);
  readonly selectedAccount$: Observable<any> = this.selectedAccountSubject.asObservable();

  constructor(private readonly http: HttpClient) { }

  setSelectedAccount(account: any): void {
    this.selectedAccountSubject.next(account);
  }

  getSelectedAccount(): any {
    return this.selectedAccountSubject.value;
  }

  createNewBalanceAccount(payload: any): Observable<any> {
    const url = `${environment.BASE_URL}/v1/balance-accounts`;
    return this.http.post(url, payload);
  }

  editBalanceAccount(id: string, payload: any): Observable<any> {
    const url = `${environment.BASE_URL}/v1/balance-accounts/${id}`;
    return this.http.put(url, payload);
  }

  getBalanceAccounts(payload: any): Observable<any> {
    const url = `${environment.BASE_URL}/v1/balance-accounts`;
    return this.http.get(url, { params: payload });
  }

  getBalanceAccountsSummary(payload: any): Observable<any> {
    const url = `${environment.BASE_URL}/v1/balance-accounts/stats`;
    return this.http.get(url, { params: payload });
  }

  getBalanceTransferSummary(balanceAccountId: string): Observable<any> {
    const url = `${environment.BASE_URL}/v1/balance-accounts/transfer/summary/${balanceAccountId}`;
    return this.http.get(url);
  }

  getBalanceTransfers(payload: any): Observable<any> {
    const url = `${environment.BASE_URL}/v1/balance-accounts/transfer`;
    return this.http.get(url, { params: payload });
  }

  createBalanceTransfer(payload: any): Observable<any> {
    const url = `${environment.BASE_URL}/v1/balance-accounts/transfer`;
    return this.http.post(url, payload);
  }
}

